<template>
  <div class="p-6 dark:text-gray-900">
    <h1 class="text-3xl font-bold mb-6 flex items-center dark:text-white">
      <button
        @click="$router.push('/modules')"
        class="mr-4 bg-blue-600 text-white px-4 py-1.5 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition duration-200 text-sm font-medium flex items-center"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4 mr-1"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
            clip-rule="evenodd"
          />
        </svg>
        Back to Modules
      </button>
      {{ isNewModule ? "Create New Module" : "Edit Module" }}
    </h1>
    <form @submit.prevent="saveModule" class="space-y-6 p-6 glass-card">
      <!-- Name Field -->
      <div>
        <label for="name" class="block text-sm font-medium text-gray-700 dark:text-white"
          >Name</label
        >
        <input
          type="text"
          id="name"
          v-model="module.name"
          required
          readonly
          class="px-3 py-2 mt-1 block w-full rounded-md dark:bg-gray-700 dark:text-white border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
        />
      </div>

      <!-- Enabled Field -->
      <div>
        <label for="enabled" class="block text-sm font-medium text-gray-700 dark:text-white"
          >Enabled</label
        >
        <input
          type="checkbox"
          id="enabled"
          v-model="module.enabled"
          class="mt-1 rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
        />
      </div>

      <!-- Organization Dropdown -->
      <div>
        <label
          for="organization"
          class="block text-sm font-medium text-gray-700 dark:text-white"
          >Organisation</label
        >
        <GlassSelect
          id="organization"
          v-model="module.uiconfig"
          :options="Object.entries(organizations).map(([id, name]) => ({ id, name }))"
          :disabled="true"
        />
      </div>

      <!-- UIConfig Field (Read-only) -->
      <div>
        <label for="uiconfig" class="block text-sm font-medium text-gray-700 dark:text-white"
          >UIconfig</label
        >
        <input
          type="text"
          id="uiconfig"
          :value="uiConfigDisplay"
          readonly
          class="px-3 py-2 mt-1 block w-full rounded-md dark:bg-gray-700 dark:text-white border-gray-300 bg-gray-100 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
        />
      </div>

      <!-- Save Button -->
      <div class="space-x-2">
        <button
          type="button"
          @click="$router.push('/modules')"
          class="btn bg-gray-300 text-gray-700 hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          {{ isNewModule ? "Create Module" : "Update Module" }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { ref, computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import {
  getModuleById,
  createModule,
  updateModule,
} from "@/services/moduleService";
import { getAllOrgs } from "@/services/orgService";
import GlassSelect from "@/components/GlassSelect.vue";

export default {
  name: "ModuleDetails",
  components: {
    GlassSelect,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const module = ref({
      name: "",
      enabled: false,
      uiconfig: "",
    });
    const organizations = ref({});
    const isNewModule = computed(() => route.params.id === "new");

    const uiConfigDisplay = computed(() => {
      const orgName = organizations.value[module.value.uiconfig];
      return orgName ? `${orgName}-config` : "";
    });

    onMounted(async () => {
      try {
        const orgs = await getAllOrgs();
        organizations.value = orgs.reduce((acc, org, index) => {
          acc[org.id] = org.name;
          return acc;
        }, {});

        if (!isNewModule.value) {
          const moduleData = await getModuleById(route.params.id);
          const modName = moduleData.name === "Blackbox"? "Endpoint Availability" : moduleData.name === "HostAvailability"? "Host Availability" : moduleData.name
          module.value = {...moduleData, name: modName};
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle error (e.g., show error message to user)
      }
    });

    const saveModule = async () => {
      const cleanedModule = {
        ...module.value, 
        name: module.value.name === "Endpoint Availability"? "Blackbox" : module.value.name === "Host Availability"? "HostAvailability" : module.value.name
      };
      try {
        if (isNewModule.value) {
          await createModule(cleanedModule);
        } else {
          await updateModule(module.value.id, cleanedModule);
        }
        router.push({ name: "Modules" });
      } catch (error) {
        console.error("Error saving module:", error);
        // Handle error (e.g., show error message to user)
      }
    };

    return {
      module,
      organizations,
      isNewModule,
      uiConfigDisplay,
      saveModule,
    };
  },
};
</script>
